import { ScrollSnapCarousel } from 'src/pages/components/ScrollSnapCarousel';
import { MODAL_MAIN_CONTENT_HEIGHT } from 'src/pages/consumer/components/DishFirstHeader';
import styled, { css } from 'styled-components';
import { match } from 'ts-pattern';
import { Border, Colors, Font, Mixins, Spacing } from 'web-common/src/shared/styles';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  overflow: scroll;
`;

export const CuisineCarousel = styled(ScrollSnapCarousel)`
  max-width: 1170px;
  justify-content: flex-start;

  ${Mixins.Media.maxWidthSmall(css`
    max-width: 100%;

    p {
      font-size: 12px;
    }
  `)}
  }
`;

export const InlineContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 100%;
  height: calc(${Spacing.QUADRUPLE} + ${Spacing.THREE_QUARTERS});
  max-width: 100%;
  margin: 0 0 ${Spacing.SINGLE};
`;

export const InlineChildren = styled.div`
  display: flex;
  flex-direction: row;
  flex: 100%;
  width: 100%;
  overflow-x: auto;
  gap: ${Spacing.HALF};
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  & button {
    transform: translateY(0) !important;
  }
`;

export const Button = styled.button<{ isSelected?: boolean; showInline?: boolean }>`
  align-items: center;
  cursor: pointer;
  display: flex;

  ${({ isSelected = false, showInline = false }) =>
    match({ showInline })
      .with(
        { showInline: true },
        () => css`
          background: none;
          border: none;
          flex-direction: column;
          justify-content: center;
        `
      )
      .otherwise(
        () => css`
          background: ${isSelected ? Colors.KOHLRABI_LITE_40 : Colors.WHITE};
          border: ${Border.Base} ${isSelected ? Colors.KOHLRABI : Colors.GRAY_LITE_10};
          border-radius: ${Border.Radius.M};
          flex-direction: row;
          justify-content: flex-start;
          gap: ${Spacing.HALF};
          padding: 0 ${Spacing.SINGLE};
        `
      )}
`;

export const ButtonIcon = styled.img`
  cursor: pointer;
  height: ${Spacing.QUADRUPLE};
  width: ${Spacing.QUADRUPLE};
`;

type ButtonLabelProps = { isSelected?: boolean; showInline?: boolean; squareButton?: boolean; underline?: boolean };

export const ButtonLabel = styled.div<ButtonLabelProps>`
  font-family: ${Font.Family.SANS};

  ${({ isSelected = false, showInline = false, squareButton = false, underline = false }) =>
    match<ButtonLabelProps>({ showInline, squareButton })
      .with(
        { squareButton: true },
        () => css`
          color: ${Colors.GRAY_DARK_30};
          font-size: ${Font.Size.XS};
          font-weight: ${Font.Weight.MEDIUM};
          white-space: nowrap;
          padding: 0 ${Spacing.DOUBLE};
        `
      )
      .with(
        { showInline: true },
        () => css`
          color: ${isSelected ? Colors.GRAY_DARK_30 : Colors.GRAY_DARK_10};
          font-size: ${Font.Size.XS};
          font-weight: ${Font.Weight.MEDIUM};
          white-space: nowrap;
          text-decoration: ${isSelected && underline ? 'underline' : 'none'};
        `
      )
      .otherwise(
        () => css`
          color: ${Colors.GRAY_DARK_30};
          font-size: ${Font.Size.S};
          font-weight: ${Font.Weight.MEDIUM};
        `
      )}
`;

export const CuisineContent = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: ${Spacing.HALF};
  margin: auto;
  max-width: 1500px;
  padding: ${Spacing.SINGLE};

  ${Mixins.Media.maxWidthLarge(`
  grid-template-columns: 1fr 1fr 1fr 1fr;
`)}

  ${Mixins.Media.maxWidthMedium(`
    grid-template-columns: 1fr 1fr 1fr;
  `)}

  ${Mixins.Media.maxWidthSmall(`
    display: flex;
    flex-direction: column;
    overflow: scroll;
    height: ${MODAL_MAIN_CONTENT_HEIGHT};
  `)}
`;

export const LoadingButton = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 11px ${Spacing.SINGLE};
`;

export const LoadingIcon = styled.div`
  height: ${Spacing.TRIPLE_HALF};
  width: ${Spacing.TRIPLE_HALF};
  border-radius: 100%;
  background: ${Colors.GRAY_LITE_30};
  margin-bottom: ${Spacing.THREE_QUARTERS};
`;

export const LoadingLabel = styled.div`
  width: ${Spacing.DOUBLE_THREE_QUARTERS};
  height: 10px;
  background: ${Colors.GRAY_LITE_30};
  border-radius: 3px;
`;
